export default "__VITE_ASSET__ce7ef6e2__"